import { createReducer, Reducer } from "@reduxjs/toolkit";
import { LoaderActions } from "./actions";
import { LoaderState } from "./models";

// Reducer
export const loaderReducer: Reducer<
  LoaderState,
  LoaderActions.Actions
> = createReducer<LoaderState>({ state: "idle" }, (builder) => {
  builder
    .addCase(LoaderActions.setDefaultLoader, (state, action) => {
      return {
        state: "loading",
        queue: state.state === "idle" ? 1 : state.queue + 1,
      };
    })
    .addCase(LoaderActions.setFileLoader, (state, action) => {
      return {
        state: "file",
        queue: state.state === "idle" ? 1 : (state.state === 'file' ? state.queue : state.queue + 1),
        ...action.payload,
      };
    })
    .addCase(LoaderActions.clearLoader, (state) => {
      if (state.state === "idle" || state.queue <= 1) {
        return { state: "idle" };
      } else {
        return { ...state , queue: state.queue - 1 };
      }
    });
});
